import { useState } from 'react';
import './header.scss';
import logo from './logo.png'
export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="header container">
            <div className="header__column" data-aos="fade-up">
                <div >
                   Logo
                </div>
            </div>

            <div className="header__column" data-aos="fade-up">
                <div
                    className={`header__burger ${menuOpen ? 'open' : ''}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <ul className={`header__navigation ${menuOpen ? 'open' : ''}`}>
                    <li className="header__link"><a onClick={() => setMenuOpen(false)} href="#about">About us</a></li>
                    <li className="header__link"><a onClick={() => setMenuOpen(false)} href="#price">Price</a></li>
                    <li className="header__link"><a onClick={() => setMenuOpen(false)} href="#info">Information</a></li>
                    <li className="header__link"><a onClick={() => setMenuOpen(false)} href="#contactBlock">Support</a></li>
                    <li className="header__link"><a onClick={() => setMenuOpen(false)} href="#contactBlock">Contact us</a></li>
                </ul>
            </div>
        </div>
    );
}
